<template>
  <div class="transportOrderEdit">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('transportOrderAdd.collapseTitle.topTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <top-form
            ref="topForm"
            deliveryType="getDeliveryType"
            :isEdit="this.$route.query.isEdit"
            :status="this.$route.query.status"
            v-if="allDetail"
            :allDetail="allDetail"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('transportOrderAdd.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form
            ref="baseForm"
            @getDeliveryType="getDeliveryType"
            :isEdit="this.$route.query.isEdit"
            :status="this.$route.query.status"
            v-if="allDetail"
            :allDetail="allDetail"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('transportOrderAdd.collapseTitle.pickUpTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <pick-up-form
            ref="pickUpForm"
            :isEdit="this.$route.query.isEdit"
            :status="this.$route.query.status"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('transportOrderAdd.collapseTitle.deliveryTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <delivery-form
            ref="deliveryForm"
            :isEdit="this.$route.query.isEdit"
            :status="this.$route.query.status"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('transportOrderAdd.collapseTitle.transportTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <transport-form
            ref="transportForm"
            :isEdit="this.$route.query.isEdit"
            :status="this.$route.query.status"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('transportOrderAdd.collapseTitle.goodsTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <goods-table
            ref="goodsTable"
            :isEdit="this.$route.query.isEdit"
            :status="this.$route.query.status"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList" v-if="$route.query.status != '3'">
      <el-button
        type="primary"
        @click="save('2')"
        v-hasPermi="['2021050814385796941']"
        :loading="load"
        class="fixed-bottom-btn"
        v-if="
          $route.query.status == '0' ||
          $route.query.status == '1' ||
          $route.query.status == '2' ||
          $route.query.status == '5'
        "
        >{{ this.$t('transportOrderAdd.btnList.save') }}</el-button
      >
      <!-- 确认 -->
      <el-button
        type="primary"
        @click="confirm('4')"
        v-hasPermi="['2021050814390791596']"
        :loading="load"
        v-if="
          $route.query.status == '1' || $route.query.status == '2' || $route.query.status == '5'
        "
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.confirm') }}</el-button
      >
      <!-- 作废 -->
      <el-button
        type="primary"
        @click="updateStatus('3')"
        v-hasPermi="['2021050814391647003']"
        :loading="load"
        v-if="$route.query.status == '1' || $route.query.status == '2'"
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.invalid') }}</el-button
      >
      <!-- 撤销 -->
      <el-button
        type="primary"
        @click="updateStatus('5')"
        :loading="load"
        v-if="$route.query.status == '4'"
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.undo') }}</el-button
      >
      <!-- 打印 -->
      <el-button
        type="primary"
        @click="print"
        :loading="load"
        v-if="$route.query.status == '4' || $route.query.status == '2'"
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.print') }}</el-button
      >
    </div>
    <print-dialog ref="printDialog" :deliveryNo="this.$route.query.deliveryNo"></print-dialog>
  </div>
</template>

<script>
  // import axios from 'axios';
  // import SiruiSearch from '@/components/SiruiSearch';
  // import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/logisticsCenter/transportOrder';
  import TopForm from './components/topForm'; // 顶部表单
  import BaseForm from './components/baseForm'; // 基本信息
  import PickUpForm from './components/pickUpForm'; // 提货信息
  import DeliveryForm from './components/deliveryForm'; // 送达信息
  import TransportForm from './components/transportForm'; // 送达信息
  import GoodsTable from './components/goodsTable'; // 送达信息
  import printDialog from './components/printDialog';
  import { mapState } from 'vuex';

  export default {
    name: 'transportOrderEdit',
    components: {
      // SiruiTable,
      // SiruiSearch,
      TopForm,
      BaseForm,
      PickUpForm,
      DeliveryForm,
      TransportForm,
      GoodsTable,
      printDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5', '6'],
        load: false,
        isEdit: false,
        status: '', //运输单状态
        componentsList: ['topForm', 'baseForm', 'pickUpForm', 'deliveryForm', 'goodsTable'],
        allDetail: '',
      };
    },
    created() {
      this.getDetail();
    },
    mounted() {
      this.isEdit = this.$route.query.isEdit;
      this.status = this.$route.query.status;
      this.version = this.$route.query.version;
    },
    methods: {
      getDetail() {
        this.loading.startLoading();
        let params = {
          deliveryNo: this.$route.query.deliveryNo,
        };
        this.$axios.get(`${API.LIST_DELIVERY_DETAIL}/${params.deliveryNo}`).then((res) => {
          if (res.data.code == 0) {
            this.loading.endLoading();
            this.$refs.pickUpForm.getDeatil(res.data.data);
            this.$refs.deliveryForm.getDeatil(res.data.data);
            this.$refs.transportForm.getDeatil(res.data.data);
            this.$refs.goodsTable.getGoodsDeatil(res.data.data);
            this.allDetail = res.data.data;
            this.version = this.allDetail.delivery.version;
            if (this.allDetail && this.allDetail.deliveryDetailList) {
              this.$refs.goodsTable.getGoodsDeatil(this.allDetail.deliveryDetailList);
            }
          }
        });
      },
      getDeliveryType(obj) {
        this.$refs.topForm.changeDeliveryType(obj.deliveryType);
        this.$refs.pickUpForm.getChooseDetail(obj);
        this.$refs.deliveryForm.getChooseDetail(obj);
        //this.$refs.goodsTable.getTableDetail(obj);
      },
      save(status) {
        this.loading.startLoading();
        let params = {};
        this.componentsList.push('transportForm');
        this.componentsList.map((item) => {
          let momentObj = this.$refs[item].exportChildData(status);
          params = Object.assign(params, momentObj);
        });
        params = {
          ...params,
          version: this.version,
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          departmentCode: this.userInfo.userInfo.departmentCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentName: this.userInfo.userInfo.departmentName,
          deliveryStatus: status,
          settle: params.settle ? '1' : '0',
          // carrierName: params.carrierName.length
          //   ? params.carrierName[0].partnerZhName
          //   : ""
          carrierName: params.carrierName,
        };
        if (this.$route.query.status == '0') {
          // 新增保存
          this.$axios.post(API.SAVE_DELIVERY, params).then((res) => {
            if (res.data.code == 0) {
              this.loading.endLoading();
              this.$message({
                showClose: true,
                message: this.$t('transportOrderAdd.msg.saveSussess'),
                type: 'success',
              });
              if (status == '2') {
                this.getDetail();
              } else {
                this.toPath();
              }
            }
          });
        } else if (
          this.$route.query.status == '1' ||
          this.$route.query.status == '2' ||
          this.$route.query.status == '5'
        ) {
          this.$axios.post(API.UPDATE_DELIVERY, params).then((res) => {
            if (res.data.code == 0) {
              this.loading.endLoading();
              this.$message({
                showClose: true,
                message: this.$t('transportOrderAdd.msg.updateSusscess'),
                type: 'success',
              });
              if (status == '2') {
                this.getDetail();
              } else {
                this.toPath();
              }
            }
          });
        }
      },
      toPath() {
        let pathList = {
          fromPath: {
            path: '/logistics/transportOrderAdd',
            name: 'transportOrderAdd',
            meta: {
              keepAlive: true,
              title: this.$t('transportOrderAdd.path.editPathName'),
            },
          },
          toPath: {
            path: '/logistics/transportOrderList',
            name: 'transportOrderList',
            meta: {
              keepAlive: false,
              title: this.$t('transportOrderAdd.path.listPathName'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      confirm(status) {
        let params = {};
        let flag = true;
        this.componentsList.map((item) => {
          let momentObj = this.$refs[item].exportChildData(status);
          if (momentObj == false) {
            flag = false;
          } else {
            params = Object.assign(params, momentObj);
          }
        });
        if (!flag) {
          this.$message({
            showClose: true,
            message: '请填写完整的表单信息',
            type: 'error',
          });
          return;
        }
        params = {
          ...params,
          version: this.version,
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          departmentCode: this.userInfo.userInfo.departmentCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentName: this.userInfo.userInfo.departmentName,
          deliveryStatus: status,
        };
        Promise.resolve(this.$refs.transportForm.exportChildData(status)).then((res) => {
          if (res) {
            params = Object.assign(params, res);
            // params.carrierName = params.carrierName;
            // params.carrierName = params.carrierName.length
            //   ? params.carrierName[0].partnerZhName
            //   : "";
            // 编辑确认
            // if (params.deliveryTransportList.length == 0) {
            //   this.$message({
            //     showClose: true,
            //     message: "请填写运输载具信息",
            //     type: "error"
            //   });
            // } else {
            this.loading.startLoading();
            this.$axios.post(API.UPDATE_DELIVERY, params).then((res) => {
              if (res.data.code == 0) {
                this.loading.endLoading();
                this.$message({
                  showClose: true,
                  message: this.$t('transportOrderAdd.msg.comfirmSusscess'),
                  type: 'success',
                });
                let pathList = {
                  fromPath: {
                    path: '/logistics/transportOrderAdd',
                    name: 'transportOrderAdd',
                    meta: {
                      keepAlive: true,
                      title: this.$t('transportOrderAdd.path.editPathName'),
                    },
                  },
                  toPath: {
                    path: '/logistics/transportOrderList',
                    name: 'transportOrderList',
                    meta: {
                      keepAlive: false,
                      title: this.$t('transportOrderAdd.path.listPathName'),
                    },
                  },
                };
                this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
                  this.$nextTick(() => {
                    this.$router.push(pathList.toPath);
                  });
                });
              }
            });
            // }
          }
        });
      },
      // 改变运输单状态
      updateStatus(status) {
        this.loading.startLoading();
        let message =
          status == '4'
            ? this.$t('transportOrderAdd.btnList.confirm')
            : status == '5'
            ? this.$t('transportOrderAdd.btnList.undo')
            : status == '3'
            ? this.$t('transportOrderAdd.btnList.invalid')
            : '';
        let params = {
          deliveryNo: this.$refs['topForm'].exportChildData(status).deliveryNo,
          deliveryStatus: status,
          version: this.$route.version,
        };
        this.$axios.post(API.UPDATE_DELIVERY_STATUS, params).then((res) => {
          if (res.data.code == 0) {
            this.loading.endLoading();
            this.$message({
              showClose: true,
              message: `${message}${this.$t('transportOrderAdd.msg.success')}`,
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: `${message}${this.$t('transportOrderAdd.msg.error')}`,
              type: 'error',
            });
          }
          let pathList = {
            fromPath: {
              path: '/logistics/transportOrderAdd',
              name: 'transportOrderAdd',
              meta: {
                keepAlive: true,
                title: this.$t('transportOrderAdd.path.editPathName'),
              },
            },
            toPath: {
              path: '/logistics/transportOrderList',
              name: 'transportOrderList',
              meta: {
                keepAlive: false,
                title: this.$t('transportOrderAdd.path.listPathName'),
              },
            },
          };
          this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
            this.$nextTick(() => {
              this.$router.push(pathList.toPath);
            });
          });
        });
      },
      // 打印
      print() {
        this.$refs.printDialog.openDialog(true);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .transportOrderEdit {
    padding: 10px;
    background-color: #fff;
  }
</style>
